export const GET_SCREENER = 'GET_SCREENER'
export const GET_SCREENER_SUCCESS = 'GET_SCREENER_SUCCESS'
export const GET_SCREENER_ERROR = 'GET_SCREENER_ERROR'

export const GET_SIGNED_URL = 'GET_SIGNED_URL'
export const GET_SIGNED_URL_SUCCESS = 'GET_SIGNED_URL_SUCCESS'
export const GET_SIGNED_URL_ERROR = 'GET_SIGNED_URL_ERROR'
